<button nz-button nzType="link" *ngIf="language === 'zh'" nzTrigger="click" nz-dropdown [nzDropdownMenu]="lang"
    [nzPlacement]="'bottomCenter'">
    <i nz-icon nzType="mm:lang-switch-en" nzTheme="outline" class="icon-size"></i>
    <ng-content></ng-content>

</button>
<button nz-button nzType="link" *ngIf="language === 'en'" nzTrigger="click" nz-dropdown [nzDropdownMenu]="lang"
    [nzPlacement]="'bottomCenter'">
    <i nz-icon nzType="mm:lang-switch-zh" nzTheme="outline" class="icon-size"></i>
    <ng-content></ng-content>
</button>
<nz-dropdown-menu #lang="nzDropdownMenu">
    <ul nz-menu nzSelectable class="drpMenu">
        <li nz-menu-item [nzSelected]="language === 'zh'" (click)="selectLang('zh')">中文</li>
        <li nz-menu-item [nzSelected]="language === 'en'" (click)="selectLang('en')">English</li>
    </ul>
</nz-dropdown-menu>